export const GET_INTERACTIONS = "GET_INTERACTIONS";
export const SET_INTERACTIONS = "SET_INTERACTIONS";
export const API_ERROR = "INTERACTIONS_API_ERROR";